import { render } from "./VasService.vue?vue&type=template&id=a472c6d6&scoped=true"
import script from "./VasService.vue?vue&type=script&lang=js"
export * from "./VasService.vue?vue&type=script&lang=js"

import "./VasService.vue?vue&type=style&index=0&id=a472c6d6&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a472c6d6"]])

export default __exports__